import { createFeature, createReducer, createSelector, on } from '@ngrx/store';
import {
  AsyncRequestStatus,
  requestStatusFailure,
  requestStatusInProgress,
  requestStatusSuccess
} from '@portal/shared/store/request-status';
import { SideMenuStateActions } from './side-menu-state.actions';
import { initialSideMenuStateState } from './side-menu-state.state';

const sideMenuStateReducer = createReducer(
  initialSideMenuStateState,
  on(SideMenuStateActions.getMenuState, state => ({
    ...state,
    loadRequest: requestStatusInProgress()
  })),
  on(SideMenuStateActions.getMenuStateSuccess, (state, { menuState }) => ({
    ...state,
    menuState,
    loadRequest: requestStatusSuccess()
  })),
  on(SideMenuStateActions.getMenuStateFailure, (state, { error }) => ({
    ...state,
    menuState: null,
    loadRequest: requestStatusFailure(error)
  })),
  on(SideMenuStateActions.saveMenuState, (state, { menuState }) => ({
    ...state,
    menuState,
    saveRequest: requestStatusInProgress()
  })),
  on(SideMenuStateActions.saveMenuStateSuccess, state => ({
    ...state,
    saveRequest: requestStatusSuccess()
  })),
  on(SideMenuStateActions.saveMenuStateFailure, (state, { error }) => ({
    ...state,
    saveRequest: requestStatusFailure(error)
  })),
  on(SideMenuStateActions.setHorizontalExpanded, (state, { horizontalExpanded }) => ({
    ...state,
    menuState: {
      sections: state.menuState?.sections ?? {},
      items: state.menuState?.items ?? {},
      horizontalExpanded
    },
    saveRequest: requestStatusInProgress()
  }))
);

export const sideMenuStateFeature = createFeature({
  name: 'sideMenuState',
  reducer: sideMenuStateReducer,
  extraSelectors: ({ selectLoadRequest }) => ({
    selectIsMenuStateLoaded: createSelector(
      selectLoadRequest,
      r => r.status === AsyncRequestStatus.Success || r.status === AsyncRequestStatus.Failure
    )
  })
});

export const { selectMenuState, selectLoadRequest, selectSaveRequest, selectIsMenuStateLoaded } = sideMenuStateFeature;
